import { UtilityPlugin } from "../plugins/utility_plugin.js";
import { MessageReader } from "./message_handlers/message_reader.js";

export class WebSocketClient
{
  private ws: WebSocket | null = null;

  public connect(
    server_url: string,
    on_open: () => void,
    on_command: ( reader: MessageReader ) => void,
    on_close: ( event: CloseEvent ) => void,
  ): void
  {
    if ( this.ws && this.ws.readyState !== WebSocket.CLOSED )
    {
      this.ws.onclose = null;
      this.ws.close();
    }

    const ws = new WebSocket( server_url );
    this.ws = ws;
    ws.binaryType = 'arraybuffer';

    ws.onopen = () =>
    {
      void UtilityPlugin.reportAppStart( 'server_connect', 'success' );
      console.info( `[WebSocket] connected: ${server_url}` );
      on_open();
    };

    ws.onmessage = ( event: MessageEvent<unknown> ) =>
    {
      if ( event.data instanceof ArrayBuffer )
      {
        on_command( new MessageReader( event.data ) );
        return;
      }
      console.warn( '[WebSocket] ignored non-binary message' );
    };

    ws.onerror = error =>
    {
      void UtilityPlugin.reportAppStart( 'server_connect', 'failed' );
      console.warn( '[WebSocket] connection error', error );
    };

    ws.onclose = event =>
    {
      if ( this.ws === ws ) this.ws = null;
      console.warn( `[WebSocket] closed: code=${event.code}, reason=${event.reason || 'none'}` );
      on_close( event );
    };
  }

  public disconnect(): void
  {
    if ( !this.ws ) return;
    this.ws.onclose = null;
    this.ws.close();
    this.ws = null;
  }

  public send( message: ArrayBuffer ): boolean
  {
    if ( !this.ws || this.ws.readyState !== WebSocket.OPEN ) return false;
    this.ws.send( message );
    return true;
  }
}
